export default {"src":"/blog/_next/static/media/google-play.face6174.svg","height":40,"width":136};